var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutreachLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 29.9 29",
    style: {
      enableBackground: "new 0 0 29.9 29"
    },
    xmlSpace: "preserve",
    "data-ember-extension": 1,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#5952FF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.3,0c4.6,0,11.5,1.4,14.7,4.7c0.8,0.8,1.9,2.4,1.9,4.8c0,4.2-3.4,10.6-7.1,14.3c-1.9,1.9-5,4.4-9.1,4.4  c-4,0-7.1-2.7-8-3.6C2.4,21.2,0,16,0,11.2c0-3,0.9-5.7,3.1-7.9C5.1,1.2,8.6,0,13.3,0z M19,16.7c1.5-1.6,2-3.5,2-4.5  c0-0.8-0.2-1.9-1.2-2.8c-1.5-1.5-3.1-1.9-4.8-1.9c-2.2,0-3.7,0.7-4.7,1.7c-0.8,0.8-1.5,2-1.5,3.7c0,1.7,0.9,3.4,1.9,4.4  c0.9,0.9,2.4,1.6,3.8,1.6S17.4,18.3,19,16.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutreachLogo);
export default __webpack_public_path__ + "static/media/outreach_logo.d42947fa712766456bab4629574f9914.svg";
export { ForwardRef as ReactComponent };